import $ from "jquery"
import "parsleyjs"

const options = {
	successClass: "has-success",
	errorClass: "has-error",
	classHandler(field) {
		return field.$element.parents(".form__field")
	},
	errorsWrapper: "<ul class=\"form__errors\"></ul>",
}

window.Parsley.on("form:validated", (form) => {
	$("html, body").animate({
		scrollTop: form.$element.offset().top,
	}, 150)
})

const forms = Array.from(document.querySelectorAll(".js-form-validate"))
forms.forEach(element => $(element).parsley(options))
// Add animation events
const animatedFields = Array.from(document.querySelectorAll(".js-animated-field"))
animatedFields.forEach((field) => {
	const input = field.querySelector("input") || field.querySelector("textarea")

	if (input.value.length) {
		field.classList.add("is-focused")
	}

	input.addEventListener("focus", () => {
		field.classList.add("is-focused")
	})

	input.addEventListener("blur", () => {
		if (!input.value.length) {
			field.classList.remove("is-focused")
		}
	})
})